var defaultStyles = {
  "root": "Base-Checkbox",
  "boxed": "Base-Checkbox--Boxed",
  "box": "Base-Checkbox--Box",
  "blocked": "Base-Checkbox--Blocked",
  "hidden": "Base-Checkbox--Hidden",
  "disabled": "Base-Checkbox--Disabled",
  "checked": "Base-Checkbox--Checked",
  "sm": "Base-Checkbox--Sm",
  "md": "Base-Checkbox--Md",
  "lg": "Base-Checkbox--Lg",
  "checked_icon": "Base-Checkbox--CheckedIcon",
  "content": "Base-Checkbox--Content",
  "label": "Base-Checkbox--Label",
  "doubleLabel": "Base-Checkbox--DoubleLabel",
  "hint": "Base-Checkbox--Hint",
  "prefix": "Base-Checkbox--Prefix",
  "group": "Base-Checkbox--Group",
  "vertical": "Base-Checkbox--Vertical",
  "horizontal": "Base-Checkbox--Horizontal",
  "input": "Base-Checkbox--Input"
};

export { defaultStyles as default };
